import * as FPAIConstants from '../constants';

import * as FPAIWorkers from './workers';

export default [
  {
    actionType: FPAIConstants.Actions.INITIATE_FAMILY_PLAN_INVITEE_FLOW,
    handler: FPAIWorkers.onInitiateFamilyPlanInviteeFlow,
    concur: 'takeEvery',
  },
  {
    actionType: FPAIConstants.Actions.FAMILY_CHILD_CONTINUE_CLICKED,
    handler: FPAIWorkers.onFamilyChildContinueClicked,
    concur: 'takeEvery',
  },
];
